module.exports = __webpack_public_path__ + "media/about-us_bgmovie_640x360.2ad3dbf8.mp4";